import {Component, ElementRef, Input} from '@angular/core';
import {kanUsersService} from "../../../../services/services/users";
import {MatDialog, PageEvent} from "@angular/material";
import {Dog} from "../../../../../classes/dog";
import {kanDogsService} from "../../../../services/services/dogs";
import {kanDogDialog} from "../../../dialogs/dog-dialog/component";
import {User} from "../../../../../classes/user";
import {kanAuthService} from "../../../../services/services/auth";
import {MembershipType} from "../../../../../classes/membershipType";
import {kanMembershipService} from "../../../../services/services/membership";
import * as XLSX from 'xlsx';

@Component({
    selector: 'kan-dogs',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    providers: [kanUsersService]
})
export class kanDogs {

    @Input() public selectedTab: number;
    public loading: boolean = false;
    public dogs: Dog[] = [];
    public filteredDogs: Dog[] = [];
    public pagedDogs: Dog[] = [];
    public search: string = '';
    public sortBy: string = 'name';
    public sortByOptions: any[] = [
        {
            title: 'NAME',
            field: 'name'
        },
        {
            title: 'RACE',
            field: 'race'
        },
        {
            title: 'OWNER',
            field: 'owner'
        }];
    public sortDirection: string = 'ASC';
    public sortDirections: string[] = ['ASC', 'DESC'];
    public members: boolean = false;
    public membershipTypes: MembershipType[] = [];
    public selectedMembershipType: string = '';
    public pageIndex: number = 0;
    public pageSize: number = 20;
    public totalDogs: number = 0;
    private filter: any = {
        where: {
            and: [
                {
                    active: true
                }
            ]
        },
        order: `${this.sortBy} ${this.sortDirection}`,
        skip: 0,
        limit: 20,
        include: ['owner', 'membershipType']
    };
    public timeout: any;

    constructor(private element: ElementRef,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private dogsService: kanDogsService,
                private membershipService: kanMembershipService) {
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 1) {
            this.getDogs();
            this.getMembershipTypes();
        }
    }

    get role(): string {
        return this.authService.role;
    }

    public newDogDialog(event: any) {
        let dialogRef = this.dialog.open(kanDogDialog, {
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getDogs();
            }
        });
    }

    public getDogs(): void {
        this.loading = true;

        this.dogsService
            .getDogs({
                where: {active: true},
                include: ['owner', 'membershipType', 'membershipTypeLogs']
            })
            .then((dogs) => {
                this.dogs = dogs;
                this.loading = false;
                this.filterDogs();
            })
            .catch((error) => {
                console.log(error);
                this.loading = false;
            });
    }

    public getMembershipTypes(): void {
        this.membershipService.getTypes()
            .then((membershipTypes: MembershipType[]) => {
                this.membershipTypes = membershipTypes;
            })
            .catch((error: any) => {
                console.log(error);
            });
    }

    public changePage(event: PageEvent) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.filterDogs();
    }

    public filterDogs(resetPage: boolean = false) {

        if (resetPage) {
            this.pageIndex = 0;
            this.filter.skip = this.pageIndex * this.pageSize;
            this.filter.limit = this.pageSize;
        }

        this.filteredDogs = this.dogs
            .filter((item) => {

                if (this.members && !item.membershipActive) {
                    return false;
                }

                if (this.members && this.selectedMembershipType && item.membershipTypeId !== this.selectedMembershipType) {
                    return false;
                }

                if (this.search) {
                    let textArray = this.search
                        .replace(/\s+/g, ' ')
                        .trim()
                        .split(' ');

                    for (let i = 0; i < textArray.length; i++) {
                        let partialFound = this.handleize(item.name || '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.owner ? item.owner.email || '' : '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.owner ? item.owner.name || '' : '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.owner ? item.owner.surname || '' : '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.owner ? item.owner.address || '' : '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.owner ? item.owner.city || '' : '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.owner ? item.owner.cp || '' : '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.owner ? item.owner.phone || '' : '').includes(this.handleize(textArray[i]));

                        if (!partialFound) return false;
                    }
                    return true;
                }

                return true;
            })
            .sort((item1, item2) => {
                switch (this.sortBy) {
                    case 'name':
                        if (this.sortDirection === 'ASC') return this.handleize(item1.name || '') < this.handleize(item2.name || '') ?
                            -1 : this.handleize(item1.name || '') > this.handleize(item2.name || '') ? 1 : 0;
                        else return this.handleize(item1.name || '') > this.handleize(item2.name || '') ?
                            -1 : this.handleize(item1.name || '') < this.handleize(item2.name || '') ? 1 : 0;
                    case 'race':
                        if (this.sortDirection === 'ASC') return this.handleize(item1.race || '') < this.handleize(item2.race || '') ?
                            -1 : this.handleize(item1.race || '') > this.handleize(item2.race || '') ? 1 : 0;
                        else return this.handleize(item1.race || '') > this.handleize(item2.race || '') ?
                            -1 : this.handleize(item1.race || '') < this.handleize(item2.race || '') ? 1 : 0;
                    case 'owner':
                        if (!item1.owner) return 1;
                        else if (!item2.owner) return -1;
                        else if (this.sortDirection === 'ASC') return this.handleize(item1.owner.name || '') < this.handleize(item2.owner.name || '') ?
                            -1 : this.handleize(item1.owner.name || '') > this.handleize(item2.owner.name || '') ? 1 : 0;
                        else return this.handleize(item1.owner.name || '') > this.handleize(item2.owner.name || '') ?
                                -1 : this.handleize(item1.owner.name || '') < this.handleize(item2.owner.name || '') ? 1 : 0;
                    default:
                        return 0;
                }
            });

        this.pageDogs();
    }

    public pageDogs() {
        this.pagedDogs = this.filteredDogs.slice(this.filter.skip, this.filter.skip + this.filter.limit)
    }

    public handleize(text = '') {
        return text.toString().toLowerCase()
            .replace(/[áàäâ]/g, 'a')
            .replace(/[éèëê]/g, 'e')
            .replace(/[íìïî]/g, 'i')
            .replace(/[óòöô]/g, 'o')
            .replace(/[úùüû]/g, 'u');
            // .replace(/[^\w\-]+/g, '');
    }

    public exportXlsx() {

        let dogs = this.dogs.map((item) => {
            return {
                name: item.name,
                birthday: item.birthday,
                deathDate: item.deathDate,
                race: item.race,
                sterilized: item.sterilized,
                membershipType: item.membershipType ? item.membershipType.type : '',
                membershipDate: item.membershipDate,
                membershipRenewalDate: item.membershipRenewalDate,
                membershipActive: item.membershipActive,
                gender: item.gender,
                owner: item.owner ? `${item.owner.name} ${item.owner.surname ? item.owner.surname : ''}` : '',
                email: item.owner ? item.owner.email || '' : '',
                membershipNumber: item.owner ? item.owner.membershipNumber || '' : ''

            };
        });

        let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dogs);
        let workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};

        XLSX.writeFile(workbook, `dogs_export_${new Date().getTime()}.xlsx`);
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/dog/dogs/component.ts